import { Box } from "@mui/material";

import { ServiceCard } from "../../../../GoService/components/ServiceCard";

import { ServicePost } from "../../../types/post.type";

const ServicePostCard = ({ post: { service } }: { post: ServicePost }) => {
  return (
    <Box sx={{ padding: "0 16px" }}>
      <ServiceCard service={service} width="100%" />
    </Box>
  );
};

export default ServicePostCard;
